import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { getImageUrl } from '../../utils/imageLoading';
import { isPortrait } from '../../utils/size';

export const ButtonRow = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: flex-end;
    width: 100%;
    margin: 0 auto;
    align-items: flex-end;
`;

const MobileImageContainer = styled.div`
    display: flex;
    width: 100%;
    height: 120px;
    left: 0em;
    bottom: 40px;
    margin-top: 1.25em;
`;
const MobileBannerImage = styled.div`
    margin-left: -1em;
    margin-right: -1em;
    width: calc(100% + 2em);
    height: 100%;
    background-image: ${props => `url(${props.url})`};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
`;

const DesktopImageContainer = styled.div`
    display: flex;
    flex: 1;
    position: absolute;
    width: 30%;
    height: 100%;
    top: 0;
    right: 0;
`;
const DesktopBannerImage = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: calc(100% + 2em);
    height: 100%;
    background-image: ${props => `url(${props.url})`};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
`;

export const ImageBanner = props =>
    isPortrait() ? (
        <MobileImageContainer>
            <MobileBannerImage url={getImageUrl(props.mobileImageId)} />
        </MobileImageContainer>
    ) : (
        <DesktopImageContainer>
            <DesktopBannerImage url={getImageUrl(props.desktopImageId)} />
        </DesktopImageContainer>
    );

ImageBanner.propTypes = {
    desktopImageId: PropTypes.string,
    mobileImageId: PropTypes.string
};
